import { generateJwtToken } from "./api";

const cancelSubscription = (id) =>
  global.AccessType ? global.AccessType.cancelSubscription(id) : console.error("AccessType not loaded!");

const getAllPlans = () =>
  global.AccessType ? global.AccessType.getSubscriptionPlans() : console.error("AccessType not loaded!");

const getMyPlans = () =>
  global.AccessType ? global.AccessType.getSubscriptions() : console.error("AccessType not loaded!");

const getPaymentOptions = () => global.AccessType.getPaymentOptions();

const getAccessTypeUrl = (accountKey, env) => {
  const isStaging = env === "staging";
  const envDomain = isStaging ? "staging." : "";
  const sandbox = isStaging ? "&env=sandbox" : "";

  return `https://${envDomain}accesstype.com/frontend/v2/accesstype.js?key=${accountKey}${sandbox}`;
};

const loadAccessType = (accountKey, env, callback) => {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.onload = () => callback();
  script.src = getAccessTypeUrl(accountKey, env);
  document.getElementsByTagName("head")[0].appendChild(script);
};

const setAccessTypeUser = (email, mobile, id = null, name = null) => {
  return generateJwtToken(email, id, name).then((token) => {
    return global.AccessType.setUser({
      emailAddress: email,
      mobileNumber: mobile,
      accesstypeJwt: token,
    }).catch((error) => console.log(error));
  });
};

// RazorPay Payment
const makeRazorpayPayment = (currentPlan, paymentOptions) => {
  // eslint-disable-next-line camelcase
  const { id, price_cents, price_currency, title } = currentPlan;
  const subscriptionParams = {
    type: "standard",
    plan: {
      id,
      price_cents,
      price_currency,
      title,
    },
    payment: {
      payment_type: "razorpay_recurring",
      amount_cents: price_cents,
      amount_currency: price_currency,
    },
  };
  return paymentOptions.razorpay.proceed(subscriptionParams);
};

const makeJuspayPayment = (currentPlan, paymentOptions) => {
  // eslint-disable-next-line camelcase
  const { id, price_cents, price_currency, title } = currentPlan;
  const subscriptionParams = {
    type: "standard",
    plan: {
      id,
      price_cents,
      price_currency,
      title,
    },
    payment: {
      payment_type: "juspay",
      amount_cents: price_cents,
      amount_currency: price_currency,
    },
  };
  return paymentOptions.juspay.proceed(subscriptionParams).then((response) => {
    return response.proceed(subscriptionParams);
  });
};

const buyZeroValuePlan = async (paytmId) => {
  const paymentOpt = await global.AccessType.getPaymentOptions(0);
  const allPlans = await getAllPlans();

  if (paymentOpt && allPlans.length) {
    const paytmPlan = allPlans.find((plan) => plan.id === Number(paytmId));
    // eslint-disable-next-line camelcase
    const { id, price_cents, price_currency, title } = paytmPlan;
    const subscriptionParams = {
      type: "standard",
      plan: {
        id,
        price_cents,
        price_currency,
        title,
      },
      payment: {
        payment_type: "juspay",
        amount_cents: price_cents,
        amount_currency: price_currency,
      },
    };

    return paymentOpt.juspay.proceed(subscriptionParams);
  }
};

export {
  getAllPlans,
  getMyPlans,
  setAccessTypeUser,
  makeRazorpayPayment,
  makeJuspayPayment,
  buyZeroValuePlan,
  cancelSubscription,
  getPaymentOptions,
  loadAccessType,
};
